'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo, useState } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import localeComparator from 'I18n/utils/localeComparator';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UISearchInput from 'UIComponents/input/UISearchInput';

const MobileCategorySelect = ({
  activeSuperCategory,
  defaultValue,
  onChange,
  options: values,
  searchPlaceholder,
  superCategory,
  translateOption,
  value
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const options = useMemo(() => {
    return values.map(val => ({
      text: translateOption(val),
      value: val
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [translateOption, values]);
  const renderedInputs = useMemo(() => {
    return options.filter(option => {
      if (searchTerm) {
        const searchRegex = new RegExp(searchTerm, 'i');
        return searchRegex.test(option.text);
      }

      return true;
    }).map(option => {
      return /*#__PURE__*/_jsx(UIRadioInput, {
        checked: option.value === value && superCategory === activeSuperCategory,
        className: "m-bottom-2",
        onChange: ({
          target: {
            checked
          }
        }) => {
          if (checked) {
            onChange(option.value);
          }
        },
        children: option.text
      }, option.value);
    });
  }, [activeSuperCategory, onChange, options, searchTerm, superCategory, value]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": "categories",
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(UISearchInput, {
        onChange: ({
          target: {
            value: searchValue
          }
        }) => {
          if (searchValue.trim()) {
            setSearchTerm(searchValue);
          } else {
            setSearchTerm('');
          }
        },
        placeholder: searchPlaceholder
      })
    }), /*#__PURE__*/_jsx(UIRadioInput, {
      checked: null === value && superCategory === activeSuperCategory,
      className: "m-bottom-2",
      onChange: ({
        target: {
          checked
        }
      }) => {
        if (checked) {
          onChange(null);
        }
      },
      children: defaultValue
    }), renderedInputs]
  });
};

MobileCategorySelect.propTypes = {
  activeSuperCategory: PropTypes.string,
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(Immutable.Set)]).isRequired,
  searchPlaceholder: PropTypes.string,
  superCategory: PropTypes.string,
  translateOption: PropTypes.func.isRequired,
  value: PropTypes.string
};
export default MobileCategorySelect;